module.exports = __webpack_public_path__ + "static/img/pic_paichecs.002bcbfd.png";